const state = () => ({
    scrollPosition: 0,
    csrfToken: '',
    isMapVisible: false,
    translations: [],
    siteUrl: '',
    isVideoOpen: false,
    videoId: '',
    isMobileMenuOpen: false,
    showContactperson: false,
    showCallMe: false,
    sliderImages: [],
    isSliderOpen: false,
    isLanguageSelectorOpen: true
})

// Getters
const getters = {
    scrollPosition: (state, getters) => {
        return state.scrollPosition
    }
}

// Actions
const actions = {
    showVideo({ commit, state }, videoId) {
        commit('setVideoId', videoId)
        commit('setVideoVisibility', true)
    },
    closeVideo({ commit, state }) {
        commit('setVideoId', '')
        commit('setVideoVisibility', false)
    },
    showSlider({ commit, state }, images) {
        commit('setImages', images)
        commit('setSliderVisibility', true)
    },
    closeSlider({ commit, state }) {
        commit('setImages', [])
        commit('setSliderVisibility', false)
    }
}

// Mutations
const mutations = {

    setLanguageSelectorState(state, value) {
        state.isLanguageSelectorOpen = value
    },
    setScrollPosition(state, position) {
        state.scrollPosition = position
    },
    setCsrfToken(state, token) {
        state.csrfToken = token
    },
    setTranslations(state, value) {
        state.translations = value
    },
    setSiteUrl(state, value) {
        state.siteUrl = value
    },
    setHover(state, value) {
        state.megahover = value
    },
    setVideoId(state, value) {
        state.videoId = value
    },
    setVideoVisibility(state, value) {
        state.isVideoOpen = value
    },
    setMobilemenuState(state, value) {
        state.isMobileMenuOpen = value
    },
    setContactpersonState(state, value) {
        state.showContactperson = value
    },
    setCallMeState(state, value) {
        state.showCallMe = value
    },
    setImages(state, value) {
        state.sliderImages = value
    },
    setSliderVisibility(state, value) {
        state.isSliderOpen = value
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
